import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";
import { UsersService } from "../../services/users/users.service";
import { Router, RouterOutlet, RouterModule } from "@angular/router"; 

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
  selector: 'app-guest',
  templateUrl: './guest.component.html',
  styleUrls: ['./guest.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatSidenavModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatListModule,
    MatTooltipModule
] 
})
export class GuestComponent {

}
